import { Button, Col, Form, Row, Typography } from 'antd'
import React, { useState } from 'react'
import { FormBox, InputBox } from '../../../../components/AntdAddons'
import { rules } from './Rules'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { assignErrorToInput } from '../../../../store/api'
import { updatePassword } from '../../../../store/AuthSlice'
import { AppDispatch, RootState } from '../../../../store/app'
import { useDispatch, useSelector } from 'react-redux'
import loginlogo from "../../../../assets/images/login-logo.svg"
import { CheckCircleOutlined } from '@ant-design/icons'
const { Text } = Typography;
import loginbgMob from "../../../../assets/images/login-img-new-mobile.svg"
import { WebConstant } from '../../webConstant/WebConstant'


/**
 * Renders the ChangePassword component.
 *
 * @return {JSX.Element} The rendered ChangePassword component.
 */
const ChangePassword = () => {
    const navigate = useNavigate()
    const [form] = Form.useForm();
    const { otp }: any = useParams();
    const dispatch: AppDispatch = useDispatch();
    const [passwordIsChanged, setPasswordIsChanged] = useState(false);


    const resetPassword = (data: any) => {
        data.otp = otp
        localStorage.removeItem('token')
        dispatch(updatePassword(otp, data)).then(() => {
            form.resetFields();
            setPasswordIsChanged(true);
            setTimeout(() => {
                setPasswordIsChanged(false);
                navigate('/login')
            }, 3000);
        }).catch((error: any) => {
            assignErrorToInput(form, error?.STATUS);
        })
    }

    const logo = useSelector((state: RootState) => state.HOME.pageSettings?.banner?.banner_logo)

    return (
        <section className='webLoginSection webRegisterSection '>
            <Row className='no-gutter'>
                <Col xxl={12} xl={12} lg={12} md={24} sm={24}>
                    <div className="login-bg">
                        <div className="login-bg-in"><img src={loginbgMob} alt="" /></div>
                    </div>
                </Col>
                <Col xxl={12} xl={12} lg={12} md={24} className='form-col'>
                    <div className='webLoginBox'>
                        <div className="login-logo">
                            <Link to={'/login'}>
                                <img src={WebConstant?.IMAGE_URL +logo} alt="" />
                            </Link>
                        </div>
                        <h2 className="subtitle">Reset Password</h2>
                        <p>Securely set a new password for your account.</p>
                        <FormBox form={form} onFinish={resetPassword}>
                            <Row>
                                <Col sm={24} xs={24} md={24} xxl={24}>
                                    <InputBox.Password
                                        name="password"
                                        // placeholder='Password'
                                        label={<>Password <em>*</em></>}
                                        placeholder=''
                                        className='ecn-input'
                                        rules={rules.password()}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col sm={24} xs={24} md={24} xxl={24}>
                                    <InputBox.Password
                                        name="password_confirmation"
                                        // placeholder='Confirm Password'
                                        label={<>Confirm Password <em>*</em></>}
                                        placeholder=''
                                        className='ecn-input'
                                        rules={rules.password_confirmation()}
                                    />
                                </Col>
                            </Row>
                            {passwordIsChanged && <Text strong style={{ color: "#1dab3b" }}><CheckCircleOutlined style={{ marginRight: '5px' }} />Password changed successfuly</Text>}
                            <div className='logInBtn'>
                                <Button className='log_in_button secondry_btn_log_page' htmlType='submit'>
                                    Submit
                                </Button>
                            </div>
                        </FormBox>
                    </div>

                </Col>
            </Row>
           
        </section>
    )
}

export default ChangePassword